










































import { Vue, Component, Watch, Prop } from 'vue-property-decorator';

import CloseModalIcon from '@/components/icons/CloseModal.vue';
import Typography from '@/componentsV2/atoms/Typography/Typography.vue';
import FilledButton from '@/components/molecules/FilledButton/FilledButton.vue';

import { isRemoteLoading } from '@/utils/remote-loading';

// ICONS
import AlertWarning from '@/components/icons/AlertWarning.vue';
import AlertDelete from '@/components/icons/AlertDelete.vue';

enum ConfirmationModalType {
  WARNING = 'warning',
  DELETE = 'delete',
  DEFAULT = 'default'
}

@Component({
  components: {
    Typography,
    CloseModalIcon,
    FilledButton,
    AlertWarning,
    AlertDelete
  }
})
export default class ConfirmationModal extends Vue {
  @Prop() type!: ConfirmationModalType;
  @Prop(String) title!: string;
  @Prop(String) description!: string;
  @Prop(String) confirmLabel!: string;
  @Prop(String) cancelLabel!: string;
  @Prop({ default: false }) loading?: boolean;
  @Prop() onConfirm?: () => void;
  @Prop() onClose?: () => void;

  loadingConfirmation = false;

  get configByType() {
    return {
      [ConfirmationModalType.WARNING]: {
        iconComponent: 'AlertWarning',
        confirmColorSchema: 'purple',
        cancelColorSchema: 'primary-outline'
      },
      [ConfirmationModalType.DELETE]: {
        iconComponent: 'AlertDelete',
        confirmColorSchema: 'danger',
        cancelColorSchema: 'outlined'
      },
      [ConfirmationModalType.DEFAULT]: {
        iconComponent: '',
        confirmColorSchema: 'primary',
        cancelColorSchema: 'outlined'
      }
    };
  }

  get remoteLoading() {
    return isRemoteLoading();
  }

  get currentConfig() {
    return this.configByType[this.type];
  }

  created() {
    document.onkeydown = this.handleOnkeydown;
    this.resizeEventHandler();
  }

  @Watch('$route')
  onRouteChange() {
    this.onCloseModal();
  }

  onCloseModal() {
    this.$emit('close');
    if (this.onClose) this.onClose();
  }

  async onConfirmModal() {
    this.$emit('confirm');
    if (this.onConfirm) {
      try {
        this.loadingConfirmation = true;
        await this.onConfirm();
      } finally {
        this.loadingConfirmation = false;
      }
    }
  }

  handleOnkeydown({ key }: KeyboardEvent) {
    if (key === 'Escape') {
      this.onCloseModal();
    }
  }

  resizeEventHandler() {
    const vh = window.innerHeight * 0.01;

    document.documentElement.style.setProperty(
      '--confirmation-modal-vh',
      `${vh}px`
    );
  }
}
